import React, { useRef, useEffect, useLayoutEffect, useState, Fragment } from 'react';
import queryString from 'query-string';
import DateTime from '../../components/DateTime/DateTime';
import Mapbox from '../../components/Mapbox/Mapbox';
import ReactWeather from 'react-open-weather';
import Tips from '../../components/Tips/Tips';
import { environment } from '../../environments/environment';
import APIService from './../../shared/api-service';
import Header from '../../components/Header/Header';
import 'react-open-weather/lib/css/ReactWeather.css';

import './landing.scss';

declare global {
    namespace JSX {
        interface IntrinsicElements {
            'news-reader': any; // React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
            'weather': any; //React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
        }
    }
}

interface LatLong {
  latitude: number | undefined
  longitude: number | undefined
}

export default function Landing(prop: any) {
  let selectedFeed = useRef<string>();
  const [size, setSize] = useState([0, 0]);
  const [newsFeeds, setNewsFeeds] = useState<any>();
  console.log('LandingPage');
  console.log(prop);
  const parsed = queryString.parse(prop.location.search);
  const latitude: number | undefined = parsed.latitude ? +parsed.latitude : undefined;
  const longitude: number | undefined = parsed.longitude ? +parsed.longitude : undefined;
  const [content, setContent] = useState<string>('1');
  const [select, setSelected] = useState<string>();
  const [pos, setPos] = useState<LatLong>({latitude: undefined, longitude: undefined});
  let initialized = useRef<boolean>(false);
  
  let newsReaderRef = useRef();

  useEffect(() => {
    const apiService = new APIService();
    apiService.retrieveRSSFeeds()
    .then((feedsObj) => {
      setNewsFeeds(feedsObj?.feeds);
    })
  }, [])

  useEffect(() => {
    if (newsFeeds && newsFeeds.length > 0) {
      let b: any = newsReaderRef;
      if (!b.item) {
        b.item=newsFeeds;
        b.radioSelection=content;
        console.log('a');
        if (!selectedFeed.current) {
          console.log('b');
          selectedFeed.current = newsFeeds[0].url;
          setSelected(selectedFeed.current);
        }
      }
    }
  }, [newsFeeds, size, content]);

  useEffect(() => {
    if (!initialized.current) {
      // If the latitude and longitude were passed in via the query then use that, else try to get the current position.
      if (latitude && longitude) {
        initialized.current = true;
        setPos({ latitude: latitude, longitude: longitude});
      } else {
        navigator.geolocation.getCurrentPosition((position: Position) => {
          console.dir(position);
          initialized.current = true;
          setPos({ latitude: position.coords.latitude, longitude: position.coords.longitude});
        });
      }
    }
  }, [latitude, longitude]);

  useEffect(() => {
    let b: any = newsReaderRef;
    b.addEventListener("selection", handleSelectionChange);
    b.addEventListener("content", handleContentChange);
    return () => {
      b.removeEventListener("selection", handleSelectionChange);
      b.removeEventListener("content", handleContentChange);
    }
  }, [size]);

  function handleSelectionChange(event: any) {
    console.log('Selection was changed!')
    selectedFeed.current = event.detail;
    setSelected(selectedFeed.current);
  }

  function handleContentChange(event: any) {
    console.log('Content was changed!');
    setContent(event.detail);
  }

  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    setTimeout(() => updateSize(), 10);

    return () => {
      window.removeEventListener('resize', updateSize);
    }
  }, []);

  let weatherDiv;
  if (initialized.current) {
    weatherDiv = <div>
                    <ReactWeather className="app-weather"
                      forecast="5days"  
                      apikey={environment.weatherApiKey}
                      type="geo"
                      unit="imperial"
                      lat={pos.latitude ? "" + pos.latitude : undefined}
                      lon={pos.longitude ? "" + pos.longitude : undefined}
                    />
                  </div>;
  } else {
    weatherDiv = <span></span>;
  }

  let newsDiv;
  if (initialized.current) {
    newsDiv = <Mapbox latitude={pos.latitude} longitude={pos.longitude} />
  } else {
    newsDiv = <span></span>
  }

  let tipsDiv;
  if (content === '2') {
    tipsDiv = <div className="canvas">
                <Tips />
              </div>
  } else {
    tipsDiv = <></>
  }

  let news = <div>
              <news-reader ref={(ref: any) => newsReaderRef = ref} selected={select} selection={handleSelectionChange}/>
              {tipsDiv}
            </div>;

  let timeWeatherMap = <Fragment>
                        <div className='row-app-time'>
                          <DateTime className='app-time'/>
                        </div>
                        <div className='row-app-weather'>
                          {weatherDiv}
                        </div>
                        <div className='row-app-location'>
                          {newsDiv}
                        </div>
                        <div className='row'>
                          <div className='separator'></div>
                        </div>
                       </Fragment>;

  let layout;
  if (size[0] >= 1160) {
    layout = <div className="row"><div className="col-md-9">{news}</div><div className="col-md-3">{timeWeatherMap}</div></div>;
  } else {
    layout = <Fragment><div className="col-md-12">{timeWeatherMap}</div><div className="col-md-12">{news}</div></Fragment>
  }

  return (
    <div>
      <Header />
      <div className="content">
        {layout}
      </div>
    </div>
  );
  
};
